(function () {
    'use strict';

    angular.module('app').factory('FuelService', FuelService);

    FuelService.$inject = ['$rootScope', 'API', 'NotifyService'];

    function FuelService($rootScope, API, NotifyService) {
        var service = {};
        /**
         * This callback type is called `requestCallback` and is displayed as a global symbol.
         *
         * @callback requestCallback
         * @param {boolean} success
         * @param {Object} data
         */

        /**
         * Return fuel controllers
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {Object} params - Parameters filter
         * @param {boolean} params.only_active - Return only active objects
         * @param {string} params.pos_id - Filter by POS Id
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.getControllerList = function (loyaltyId, params, callback) {
            var url = '/fuel/{0}/controllers?{1}'.format(loyaltyId, paramsToUrlQueryEncodeURIComponent(params));
            API.get(url, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Return fuel controller
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.getControllerItem = function (loyaltyId, controllerId, callback) {
            var url = '/fuel/{0}/controllers/{1}'.format(loyaltyId, controllerId);
            API.get(url, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Add fuel controller
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {Object} controllerData - Fuel controller data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.addFuelController = function (loyaltyId, controllerData, callback) {
            var url = '/fuel/{0}/controllers'.format(loyaltyId);
            API.post(url, controllerData, function (success, data) {
                callback(success, data);
            });
        };

        /**
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {Object} controllerData
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.updateFuelController = function (loyaltyId, controllerId, controllerData, callback) {
            var url = '/fuel/{0}/controllers/{1}'.format(loyaltyId, controllerId);
            API.patch(url, controllerData, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Set terminal for fuel pump
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {string} pumpId - Fuel pump ID
         * @param {Object} terminalData - Terminal data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.setPumpTerminal = function (loyaltyId, controllerId, pumpId, terminalData, callback) {
            var url = '/fuel/{0}/controllers/{1}/pumps/{2}/terminal'.format(loyaltyId, controllerId, pumpId);
            API.post(url, terminalData, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Remove terminal for fuel pump
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {string} pumpId - Fuel pump ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.deletePumpTerminal = function (loyaltyId, controllerId, pumpId, callback) {
            var url = '/fuel/{0}/controllers/{1}/pumps/{2}/terminal'.format(loyaltyId, controllerId, pumpId);
            API.del(url, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Set terminal for fuel pump
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {string} pumpId - Fuel pump ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.getPumpTerminals = function (loyaltyId, controllerId, pumpId, callback) {
            var url = '/fuel/{0}/controllers/{1}/pumps/{2}/terminals'.format(loyaltyId, controllerId, pumpId);
            API.get(url, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Set terminal for fuel pump
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {string} pumpId - Fuel pump ID
         * @param {Object} terminalsData - Terminals data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.updatePumpTerminals = function (loyaltyId, controllerId, pumpId, terminalsData, callback) {
            var url = '/fuel/{0}/controllers/{1}/pumps/{2}/terminals'.format(loyaltyId, controllerId, pumpId);
            API.patch(url, terminalsData, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Return fuel controller gps data by period
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {Object} params - Parameters filter
         * @param {string} params.date_from - Date and time filter from in RFC3339
         * @param {string} params.date_to - Date and time to from in RFC3339
         * @param {number} params.page - List page number
         * @param {number} params.count - Rows count in page
         * @param {boolean} params.reverse - Reverse order (from latest to oldest)
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.getGPS = function (loyaltyId, controllerId, params, callback) {
            var url = '/fuel/{0}/controllers/{1}/gps?{2}'.format(loyaltyId, controllerId, paramsToUrlQueryEncodeURIComponent(params));
            API.get(url, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Return fuel controller gps route data by period
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {Object} params - Parameters filter
         * @param {string} params.date_from - Date and time filter from in RFC3339
         * @param {string} params.date_to - Date and time to from in RFC3339
         * @param {boolean} params.suppress_stops - Suppress stops in result route data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.getGPSRoute = function (loyaltyId, controllerId, params, callback) {
            var url = '/fuel/{0}/controllers/{1}/gps/route?{2}'.format(loyaltyId, controllerId, paramsToUrlQueryEncodeURIComponent(params));
            API.get(url, function (success, data) {
                callback(success, data);
            });
        };

        service.getGPSDate = function (loyaltyId, controllerId, params, callback) {
            var url = '/fuel/{0}/controllers/{1}/gps/date?{2}'.format(loyaltyId, controllerId, paramsToUrlQueryEncodeURIComponent(params));
            API.get(url, function (success, data) {
                callback(success, data);
            });
        };
        /**
         * Return fuel controller tanks/probes measurements data by period
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {Object} params - Parameters filter
         * @param {string} params.date_from - Date and time filter from in RFC3339
         * @param {string} params.date_to - Date and time to from in RFC3339
         * @param {number} params.page - List page number
         * @param {number} params.count - Rows count in page
         * @param {boolean} params.reverse - Reverse order (from latest to oldest)
         * @param {string} params.tank_id - Filter by tank if needed
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.getTankMeasurements = function (loyaltyId, controllerId, params, callback) {
            var url = '/fuel/{0}/controllers/{1}/tanks/measurements?{2}'.format(loyaltyId, controllerId,
                paramsToUrlQueryEncodeURIComponent(params));
            API.get(url, function (success, data) {
                callback(success, data);
            });
        };
        /**
         * Return fuel controller tanks/probes measurements data on specific date
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {Object} params - Parameters filter
         * @param {string} params.date - Date and time filter from in RFC3339
         * @param {string} params.tank_id - Filter by tank if needed
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.getTankMeasurementsDate = function (loyaltyId, controllerId, params, callback) {
            var url = '/fuel/{0}/controllers/{1}/tanks/measurements/date?{2}'.format(loyaltyId, controllerId,
                paramsToUrlQueryEncodeURIComponent(params));
            API.get(url, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Set grade for pump nozzle tank
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {string} nozzleId - nozzle ID
         * @param {Object} data - grade data
         * @param {string} data.id - grade id
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.setGradeForNozzle = function (loyaltyId, controllerId, nozzleId, data, callback) {
            var url = '/fuel/{0}/controllers/{1}/nozzles/{2}/grade'.format(loyaltyId, controllerId, nozzleId);
            API.post(url, data, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Remove grade for pump nozzle tank
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {string} nozzleId - nozzle ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.removeGradeForNozzle = function (loyaltyId, controllerId, nozzleId, callback) {
            var url = '/fuel/{0}/controllers/{1}/nozzles/{2}/grade'.format(loyaltyId, controllerId, nozzleId);
            API.del(url, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Set tank for pump nozzle
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {string} nozzleId - nozzle ID
         * @param {Object} data - tank data
         * @param {string} data.id - tank id
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.setTankForNozzle = function (loyaltyId, controllerId, nozzleId, data, callback) {
            var url = '/fuel/{0}/controllers/{1}/nozzles/{2}/tank'.format(loyaltyId, controllerId, nozzleId);
            API.post(url, data, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Remove tank for pump nozzle
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {string} nozzleId - nozzle ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.removeTankForNozzle = function (loyaltyId, controllerId, nozzleId, callback) {
            var url = '/fuel/{0}/controllers/{1}/nozzles/{2}/tank'.format(loyaltyId, controllerId, nozzleId);
            API.del(url, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Set grade for fuel tank
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {string} tankId - Fuel tank ID
         * @param {Object} data - grade data
         * @param {string} data.id - grade id
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.setGradeForTank = function (loyaltyId, controllerId, tankId, data, callback) {
            var url = '/fuel/{0}/controllers/{1}/tanks/{2}/grade'.format(loyaltyId, controllerId, tankId);
            API.post(url, data, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Remove grade for fuel tank
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {string} tankId - Fuel tank ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.removeGradeForTank = function (loyaltyId, controllerId, tankId, callback) {
            var url = '/fuel/{0}/controllers/{1}/tanks/{2}/grade'.format(loyaltyId, controllerId, tankId);
            API.del(url, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Return list of fuel controller data access from external system
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.getControllerExternalAccessList = function (loyaltyId, controllerId, callback) {
            var url = '/fuel/{0}/controllers/{1}/external_data_access'.format(loyaltyId, controllerId);
            API.get(url, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Add fuel controller data access from external system
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {Object} data - Fuel controller data access from external system
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.addControllerExternalAccess = function (loyaltyId, controllerId, data, callback) {
            var url = '/fuel/{0}/controllers/{1}/external_data_access'.format(loyaltyId, controllerId);
            API.post(url, data, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Delete fuel controller data access from external system
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {string} accessId - Access ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.removeControllerExternalAccess = function (loyaltyId, controllerId, accessId, callback) {
            var url = '/fuel/{0}/controllers/{1}/external_data_access/{2}'.format(loyaltyId, controllerId, accessId);
            API.del(url, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Return fuel controller data access from external system
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {string} accessId - Access ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.getControllerExternalAccess = function (loyaltyId, controllerId, accessId, callback) {
            var url = '/fuel/{0}/controllers/{1}/external_data_access/{2}'.format(loyaltyId, controllerId, accessId);
            API.get(url, function (success, data) {
                callback(success, data);
            });
        };


        /**
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {string} accessId - Access ID
         * @param {Object} data - Fuel controller data access from external system
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.updateControllerExternalAccess = function (loyaltyId, controllerId, accessId, data, callback) {
            var url = '/fuel/{0}/controllers/{1}/external_data_access/{2}'.format(loyaltyId, controllerId, accessId);
            API.patch(url, data, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.getControllerExternalAccessScope = function (callback) {
            var url = '/external_data_access/scopes?object_type=fuel-controller';
            API.get(url, function (success, data) {
                callback(success, data);
            });
        };


        /**
         * Return average costs for specific grade based on cost per deliveries
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {string} gradeId - Grade ID
         * @param {Object} params - Parameters filter
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.getGradeAverageCostsByDate = function (loyaltyId, controllerId, gradeId, params, callback) {
            var url = '/fuel/{0}/controllers/{1}/grades/{2}/average_costs/date?{3}'.format(loyaltyId, controllerId, gradeId, paramsToUrlQueryEncodeURIComponent(params));
            API.get(url, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Return list of deliveries with average costs for specific grade
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {string} gradeId - Grade ID
         * @param {Object} params - Parameters filter
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.getGradeAverageCostsDeliveries = function (loyaltyId, controllerId, gradeId, params, callback) {
            var url = '/fuel/{0}/controllers/{1}/grades/{2}/average_costs/deliveries?{3}'.format(loyaltyId, controllerId, gradeId, paramsToUrlQueryEncodeURIComponent(params));
            API.get(url, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Change existing or add new deliveries for specific grade
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {string} gradeId - Grade ID
         * @param {Object} data - List of fuel deliveries data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.editGradeAverageCostsDeliveries = function (loyaltyId, controllerId, gradeId, data, callback) {
            var url = '/fuel/{0}/controllers/{1}/grades/{2}/average_costs/deliveries'.format(loyaltyId, controllerId, gradeId);
            API.patch(url, data, function (success, result) {
                callback(success, result);
            });
        };

        /**
         * Delete deliveries for specific grade
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {string} gradeId - Grade ID
         * @param {Object} data - List of fuel deliveries data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.deleteGradeAverageCostsDeliveries = function (loyaltyId, controllerId, gradeId, data, callback) {
            var url = '/fuel/{0}/controllers/{1}/grades/{2}/average_costs/deliveries'.format(loyaltyId, controllerId, gradeId);
            API.delete(url, data, function (success, result) {
                callback(success, result);
            });
        };

        /**
         * Return summary tanks volume for specific grade on specific date
         *
         * @param {string} loyaltyId - Loyalty ID
         * @param {string} controllerId - Controller ID
         * @param {string} gradeId - Grade ID
         * @param {Object} params - Parameters filter
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.getGradeVolumeByDate = function (loyaltyId, controllerId, gradeId, params, callback) {
            var url = '/fuel/{0}/controllers/{1}/grades/{2}/volume?{3}'.format(loyaltyId, controllerId, gradeId, paramsToUrlQueryEncodeURIComponent(params));
            API.get(url, function (success, data) {
                callback(success, data);
            });
        };

        return service;
    }
})();
